<template>
  <div class="news">
    <div class="news__title headings-font-family">{{$res.General.News}}</div>
    <div v-if="showAgencyNewsTab" class="news__tabs tabs">
      <div class="tabs__tab" :class="{'tab_active': !onlyYourNews}" @click="onlyYourNews=false">{{ $res.General.All }}</div>
      <div class="tabs__tab" :class="{'tab_active': onlyYourNews}" @click="onlyYourNews=true">{{ $res.Views.Home_NewsWidgetCategory_Regional }}</div>
    </div>
    <template v-if="filteredNews.length > 0">
      <a :href="n.generatedLinkUrl" class="block" :class="{'block_pinned' : n.pinned}" v-for="n in filteredNews" :key="n.id" target="_blank">
        <div class="block__date">{{ $formatDateLong(n.date) }}</div>
        <div class="block__name">{{ n.title }}</div>
        <div class="block__label" />
      </a>
    </template>
    <div v-else class="news__not-found">
      <svg-icon :icon="'lh:pic-search'" width="64" height="64" viewBox="0 0 100 100" />
      <div class="news__not-found-text">{{ $res.Views.CmsNewsItem_EmptyResults }}</div>
    </div>
    <a :href="newsPageUrl" target="_blank" class="news__button" role="button">
      <span>{{ $res.General.AllNews }}</span>
      <svg-icon icon="straight-arrows/right"/>
    </a>
  </div>
</template>

<script lang="ts">
import SvgIcon from "@/common/controls/SvgIconControl.vue";

export default {
  components: {
    SvgIcon,
  },
  props: {
    mainNews: {
      type: Object,
      default: () => {
      }
    },
    showAgencyNewsTab: {
      type: Boolean,
      default: false
    },
    agencyNews: {
      type: Object,
      default: () => {
      }
    },
    newsPageUrl: String,
  },
  data() {
    return {
      onlyYourNews: false,
    }
  },
  computed: {
    filteredNews() {
      return (((this.onlyYourNews ? this.agencyNews : this.mainNews) || {}).newsList || []).slice(0, 17); // todo 10450 17???
    }
  }
}
</script>

<style lang="scss" scoped>
.news {
  padding: 20px 16px;
  background: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow);
}

.news__not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 10px;
}

.news__not-found-text {
  margin-top: 15px;
  font-weight: 600;
}

.news__title {
  font-weight: 600;
  font-size: 24px;
  line-height: 38px;
}

.news__tabs {
  margin-top: 10px;
}

.tabs {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.tabs__tab {
  padding: 5px 16px;
  border-radius: var(--border-radius-md);
  cursor: pointer;
  line-height: 20px;
  align-items: center;
  color: var(--main-10);
  background-color: var(--main-50);
  
  &.tab_active {
    background-color: var(--main-10);
    color: var(--white);
  }
}

.news__button {
  margin-top: 10px;

  height: 36px;
  padding: 8px 16px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: var(--btn-primary);
  color: var(--btn-primary-text);
  border-radius: var(--border-radius-md);

  font-weight: 600;
  font-size: 13px;
  line-height: 20px;

  [dir="rtl"] & {
    svg {
      transform: rotate(180deg);
    }
  }

  &:hover {
    box-shadow: var(--shadow-hover);
  }
  
  &:active:not(:disabled) {
    background-color: var(--btn-primary-active);
  }
}

.block {
  display: block;
  padding:  16px;
  margin-top: 10px;
  background: var(--white);
  border: 2px solid var(--second-50);
  border-start-end-radius: var(--border-radius-lg);
  border-end-end-radius: var(--border-radius-lg);
  position: relative;
  color: var(--second-10);

  &:hover {
    box-shadow: var(--shadow-hover);
  }

    &.block_pinned {
    border-color: var(--main-40)
  }
}

.block + .block {
  margin-top: 10px;
}

.block__date {
  font-size: 13px;
  line-height: 20px;
  color: var(--second-20);
}

.block__name {
  font-size: 13px;
  line-height: 20px;
  margin-top: 5px;
}

.block__label {
  position: absolute;
  width: 5px;
  inset-inline-start: -2px;
  top: 0;
  bottom: 0;
  background: var(--second-50);

  .block_pinned & {
    background: var(--main-10);
  }
}
</style>



